module.exports = __webpack_public_path__ + "img/3.0eea41c4.png";